import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { BellSimple } from "@phosphor-icons/react";

export function NotificationBell() {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const load = () => api.get("/notifications/unread-count").then((r) => setCount(r.data.unread)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  return (
    <Button variant="ghost" size="icon" className="relative" data-testid="notif-bell"
      onClick={() => navigate("/benachrichtigungen")} aria-label="Benachrichtigungen">
      <BellSimple size={20} weight="bold" />
      {count > 0 && (
        <span data-testid="notif-bell-count"
          className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-danger px-1 text-[10px] font-bold text-white">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </Button>
  );
}
